import BulkUpdateRestrictedPayouts from "../../../views/BulkUpdateRestrictedPayouts";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const bulkUpdateRestrictedPayoutsRoutes = [
  {
    menuName: MenuNames.RESTRICTED_PAYOUTS,
    path: "/bulk-update-restricted-payouts",
    component: BulkUpdateRestrictedPayouts,
    exact: true,
  },
];

export default bulkUpdateRestrictedPayoutsRoutes;
